import React from 'react';
import PropTypes from 'prop-types';
import CwButton from '../cwbutton/CwButton';
import css from './TodayPicker.scss';
import moment from 'moment';
import { getDate, getUtcDate } from 'src/utils/DateUtils';

/**
 * Creates a button who's job is to set the current day as the selected dat. It does this by generating a new date
 * object which defaults to the current date.
 */
const TodayPicker = (props) => {

	const handleClick = () => {
    const dateObject = moment();
    const date = props.isDateTime ? getDate(dateObject.date(), dateObject.month(), dateObject.year()) : getUtcDate(dateObject.date(), dateObject.month(), dateObject.year());
		props.onChange(date);
	};

	return (
		<div className={css.picker}>
			<CwButton isStandard={true} onClick={handleClick} value={props.value} />
		</div>
	);
};

TodayPicker.propTypes = {
  /**
   * The localized string for the word today
   */
	value: PropTypes.string,
  /**
   * A function that should update the value in the text field when one has been selected from the Calendar.
   */
	onChange: PropTypes.func
};

export default TodayPicker;


// WEBPACK FOOTER //
// ./src/components/cwdatepicker/TodayPicker.jsx